(ns entities.expenses.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.expenses.specs :as sp]
    )
  )

(def path [:entities :expenses])

(rf/reg-entity
  :expenses
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/expenses)
                :success [:expenses/fetched]
                :error [:expenses/fetch-errored]
                :cancellable? true}})

   :patch
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/update-expenses {:input data})
                :success [:expenses/updated]
                :error [:expenses/update-errored]}})

   :spec/patch ::sp/patch
   })

(rf/reg-event-db
  :expenses/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :expenses])))

(rf/reg-event-db
  :expenses/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :expenses])))

(rf/reg-event-db
  :expenses/updated
  (rf/path path)
  (fn [_ [data]]
    (:update-expenses data)))

(rf/reg-event-db
  :expenses/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (:update-expenses data)))
